export default "__VITE_ASSET__DV51hN2G__"